export const tableColumns = {}
